module.exports = __webpack_public_path__ + "static/media/19.ff9b8ff1.jpg";